/**
 * Whether Fansly accounts get the console's React pages (ADR 0036) instead of
 * the embedded Fansly workspace. On: every Fansly page is built. A browser
 * can go back to the embedded workspace with localStorage `om.fanslyReact` =
 * '0' (the escape hatch while the React pages settle). Read once per page load.
 */
export const FANSLY_REACT_KEY = 'om.fanslyReact'

/** Every Fansly page is built (ADR 0036). */
const DEFAULT_ON = true

export function fanslyReactEnabled(storage: Pick<Storage, 'getItem'> | null = safeStorage()): boolean {
  try {
    const v = storage?.getItem(FANSLY_REACT_KEY)
    if (v === '1') return true
    if (v === '0') return false
  } catch {
    // Private mode: the default.
  }
  return DEFAULT_ON
}

function safeStorage(): Storage | null {
  try {
    return typeof localStorage === 'undefined' ? null : localStorage
  } catch {
    return null
  }
}
